<template>

    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar dark color="primary" style="position: sticky; top: 0; z-index: 1">
                <v-btn icon dark @click="Close()"><v-icon>mdi-close</v-icon></v-btn>
                <v-toolbar-title>Doador</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn dark text @click="save" :disabled="!valid">Salvar</v-btn>
                </v-toolbar-items>
                <template v-slot:extension>
                    <v-tabs v-model="tabActive" color="secondary">
                        <v-tab style="width: 150px"><div style="width: 100% ; display: flex ; align-items: center ; justify-content: space-around"><span>Geral</span><info/></div></v-tab>
                        <v-tab><div style="width: 100% ; display: flex ; align-items: center ; justify-content: space-around"><span>Boleto / NFS-e</span><info/></div></v-tab>
                        <v-tab :disabled="item.id == 0" style="width: 150px"><div style="width: 100% ; display: flex ; align-items: center ; justify-content: space-around"><span>Contatos</span><info/></div></v-tab>
                        <v-tab :disabled="!item.id">Relacionamento</v-tab>
                    </v-tabs>
                </template>
            </v-toolbar>

            <v-card-text class="mt-3">
                <v-tabs-items v-model="tabActive">
                    
                    <!-- GERAL -->
                    <v-tab-item eager>
                        <v-form id="formCadastroDoador" ref="formCadastroDoador" v-model="valid" lazy-validation >
                            <v-row>
                                <v-col cols="12" md="2">
                                    <v-select v-model="item.tipo" label="Tipo" :items="tipos" item-value="key" item-text="value" dense outlined/>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field v-model="item.nome" label="Nome" :rules="fieldRules" :counter="255" maxlength="255" dense outlined/>
                                </v-col>
                                <v-col cols="12" md="2">
                                    <v-text-field v-model="item.cpfCnpj" :label="lblCpfCnpj" :rules="fieldRules" v-mask="mskCpfCnpj" counter="18" maxlength="18" @blur="item.cpfCnpj = (item.cpfCnpj || '').toLocaleUpperCase()" @change="VerificarExistente()" dense outlined/>
                                </v-col>
                                <v-col cols="12" md="2">
                                    <v-text-field v-model="item.identidadeInscricaoEstadual" :label="lblIdentidadeInscricaoEstadual" :counter="15" maxlength="15" dense outlined/>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="4">
                                    <v-select v-model="item.relacionamentoId" label="Relacionamento (Mídia):" :rules="fieldRules" :items="relacionamentos" item-value="id" item-text="nome" dense outlined/>
                                </v-col>
                                <v-col cols="12" md="2">
                                    <v-select v-model="item.tipoIndicacao" label="Indicação" :items="simNaos" item-value="key" item-text="value" dense outlined/>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-autocomplete v-model="item.indicadorId" :items="indicadores" :loading="isLoading" :search-input.sync="searchIndicador" hide-no-data hide-selected cache-items
                                        item-text="nome" :rules="item.tipoIndicacao ? fieldRules : []" item-value="id" label="Indicador" :placeholder="item.indicador ? item.indicador.nome : 'Digite um Indicador'" :disabled="item.tipoIndicacao == 0" dense outlined>
                                    </v-autocomplete>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-select v-model="item.planoContaId" label="Plano de Contas" :items="planoContas" item-value="id" item-text="descricao" :rules="fieldRules" dense outlined/>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-select v-model="item.planoContaItemId" label="Plano de Contas (Item)" :items="planoContaItens" item-value="id" item-text="descricao" :rules="fieldRules" dense outlined/>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="2">
                                    <v-text-field v-model="item.cep" label="CEP" :rules="item.formaDoacao == 1 ? fieldRules : []" v-mask="mskCep" @change="ObterEndereco(item.cep)" dense outlined/>
                                </v-col>
                                <v-col cols="12" md="5">
                                    <v-text-field v-model="item.logradouro" label="Logradouro" :rules="item.formaDoacao == 1 ? fieldRules : []" :counter="80" maxlength="80" dense outlined/>
                                </v-col>
                                <v-col cols="12" md="1">
                                    <v-text-field v-model="item.numero" label="Número" :rules="item.formaDoacao == 1 ? fieldRules : []" :counter="10" maxlength="10" dense outlined/>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field v-model="item.bairro" label="Bairro" :rules="item.formaDoacao == 1 ? fieldRules : []" :counter="45" maxlength="45" dense outlined/>
                                </v-col>
                            </v-row>
                            <v-row v-if="item.id > 0">
                                <v-col cols="12" md="4">
                                    <v-autocomplete v-model="item.estado" label="Estado" :rules="item.formaDoacao == 1 ? fieldRules : []" :items="estados" item-value="key" item-text="value" dense outlined/>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-autocomplete v-model="item.municipioId" label="Município" :rules="item.formaDoacao == 1 ? fieldRules : []" :items="municipios" item-value="id" item-text="nome" dense outlined/>
                                </v-col>
                                <v-col cols="12" md="4" v-if="!item.municipioId">
                                    <v-text-field v-model="item.cidade" label="Cidade" :rules="item.formaDoacao == 1 ? fieldRules : []" :counter="45" maxlength="45" dense outlined/>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field v-model="item.pais" label="País" :rules="item.formaDoacao == 1 ? fieldRules : []" :counter="45" maxlength="45" dense outlined/>
                                </v-col>
                            </v-row>
                            <v-row v-else>
                                <v-col cols="12" md="4">
                                    <v-autocomplete v-model="item.estado" label="Estado" :rules="item.formaDoacao == 1 ? fieldRules : []" :items="estados" item-value="key" item-text="value" dense outlined/>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-autocomplete v-model="item.municipioId" label="Município" :rules="item.formaDoacao == 1 ? fieldRules : []" :items="municipios" item-value="id" item-text="nome" dense outlined/>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field v-model="item.pais" label="País" :rules="item.formaDoacao == 1 ? fieldRules : []" :counter="45" maxlength="45" dense outlined/>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="2">
                                    <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                                        <template v-slot:activator="{on}">
                                            <v-text-field type="date" v-model="item.dataNascimentoFundacao" :label="lblNascimentoFundacao" dense outlined>
                                                <template v-slot:prepend>
                                                    <v-icon v-on="on">mdi-calendar</v-icon>
                                                </template>
                                            </v-text-field>
                                        </template>
                                        <v-date-picker locale="pt-br" v-model="item.dataNascimentoFundacao" no-title dense outlined/>
                                    </v-menu>
                                </v-col>
                                <v-col cols="12" md="2">
                                    <v-text-field v-model="item.telefone" label="Telefone" v-mask="mskTelefone" dense outlined/>
                                </v-col>
                                <v-col cols="12" md="2">
                                    <v-text-field v-model="item.celular" label="Celular" v-mask="mskTelefone" dense outlined/>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field v-model="item.email" label="E-mail" :counter="90" maxlength="90" dense outlined/>
                                </v-col>
                                <v-col cols="12" md="2">
                                    <v-select v-model="item.situacao" label="Situação" :items="situacoes" item-value="key" item-text="value" dense outlined/>
                                </v-col>
                            </v-row>
                            
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-autocomplete v-model="item.projetoId" :items="projetos" :loading="isProjetoLoading" :search-input.sync="searchProjeto" hide-no-data hide-selected clearable
                                        item-text="codigoNome" item-value="id" label="Projeto" :placeholder="item.projeto ? item.projeto.codigoNome : 'Digite um projeto'" :rules="fieldRules" dense outlined/>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-select v-model="item.regiaoId" label="Região/Grupo" :rules="parametro.doadorGrupoObrigatorio ? fieldRules : []" :items="regioes" item-value="id" item-text="nome" dense outlined/>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-select v-model="item.pessoalId" label="Atendente" :items="atendentes" item-value="id" item-text="nome" dense outlined/>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-textarea v-model="item.observacao" label="Observações" :counter="255" maxlength="255" dense outlined/>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-textarea v-model="item.observacaoRecibo" label="Observações do Recibo" :counter="255" maxlength="255" dense outlined/>
                                </v-col>                            
                                <v-col cols="12" md="6" v-if="parametro.doadorCampo01">
                                    <v-text-field v-model="item.campo01" :label="parametro.doadorCampo01" :counter="50" maxlength="50" dense outlined/>
                                </v-col>
                                <v-col cols="12" md="6" v-if="parametro.doadorCampo02">
                                    <v-text-field v-model="item.campo02" :label="parametro.doadorCampo02" :counter="50" maxlength="50" dense outlined/>
                                </v-col>                            
                                <v-col cols="12" md="6" v-if="parametro.doadorCampo03">
                                    <v-text-field v-model="item.campo03" :label="parametro.doadorCampo03" :counter="50" maxlength="50" dense outlined/>
                                </v-col>
                                <v-col cols="12" md="6" v-if="parametro.doadorCampo04">
                                    <v-text-field v-model="item.campo04" :label="parametro.doadorCampo04" :counter="50" maxlength="50" dense outlined/>
                                </v-col>                            
                                <v-col cols="12" md="6" v-if="parametro.doadorCampo05">
                                    <v-text-field v-model="item.campo05" :label="parametro.doadorCampo05" :counter="50" maxlength="50" dense outlined/>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-tab-item>

                    <!-- NFS-e -->
                    <v-tab-item eager>
                        <v-form id="formCadastroNFSe" ref="formCadastroNFSe" v-model="valid" lazy-validation >
                            <fieldset class="pa-2">
                                <legend>Boleto</legend>
                                <v-row dense>
                                    <v-col cols="12" md="4">
                                        <v-select v-model="item.tipoContribuicao" label="Contribuição" :items="contribuicoes" item-value="key" item-text="value" dense outlined/>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <v-select v-model="item.formaDoacao" label="Forma de Doação" :items="formaPagamentos" item-value="key" item-text="value" dense outlined/>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <v-select v-model="item.emissaoRecibo" label="Emitir Recibo" :items="respostaBasicas" item-value="key" item-text="value" dense outlined/>
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <v-text-field type="number" v-model.number="item.diaBom" label="Dia Bom" :rules="diaSemanaRules" dense outlined/>
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <v-text-field type="number" v-model.number="item.doacaoProposta" label="Valor" dense outlined/>
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="12" md="4">
                                        <v-checkbox v-model="item.naoGerarRecebivel" label="Não Gerar Recebível" dense outlined/>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <v-checkbox v-model="item.enviarBoletoEmail" label="Enviar Boleto por E-mail" dense outlined/>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <v-checkbox v-model="item.aplicarJurosMulta" label="Aplicar juros e multa" dense outlined/>
                                    </v-col>
                                </v-row>
                            </fieldset>
                            
                            <fieldset class="mt-4 pa-2">
                                <legend>NFS-e</legend>
                                <v-row dense>
                                    <v-col cols="12" md="2">
                                        <v-select v-model="item.emissaoNota" label="Emitir Nota" :items="respostaBasicas" item-value="key" item-text="value" dense outlined/>
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="12" sm="4">
                                        <v-text-field :disabled="item.emissaoNota == 'N'" v-model="item.codigoServicoNota" label="Código Serviço (Nacional)" :counter="10" maxlength="10" dense outlined/>
                                    </v-col>
                                    <v-col cols="12" sm="4">
                                        <v-text-field :disabled="item.emissaoNota == 'N'" v-model="item.codigoTributacaoMunicipioNota" label="Código Tributação (Municipal)" :counter="10" maxlength="10" dense outlined/>
                                    </v-col>
                                    <v-col cols="12" sm="4">
                                        <v-text-field :disabled="item.emissaoNota == 'N'" v-model="item.codigoNbsNota" label="Código NBS" :counter="9" maxlength="9" dense outlined/>
                                    </v-col>
                                    <v-col cols="12" sm="12">
                                        <v-text-field :disabled="item.emissaoNota == 'N'" v-model="item.textoNota" label="Discrição NFSe" :counter="50" maxlength="50" dense outlined/>
                                    </v-col>
                                </v-row>
                            </fieldset>
                        </v-form>
                    </v-tab-item>

                    <!-- CONTATOS -->
                    <v-tab-item>
                        <v-data-table :headers="headerContato" :items="item.contatos" :items-per-page="-1" hide-default-footer class="elevation-1">

                            <template v-slot:top>
                                <v-toolbar flat>
                                    <v-spacer/>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                        <v-btn icon color="primary" class="mb-2" dark v-on="on" @click="AbrirDialogContato(0)">
                                            <v-icon>mdi-plus</v-icon>
                                        </v-btn>
                                        </template>
                                        <span>Novo Contato</span>
                                    </v-tooltip>
                                </v-toolbar>
                            </template>

                            <template v-slot:[`item.actions`]="{ item }">
                                <v-tooltip right>
                                    <template v-slot:activator="{ on }">
                                        <v-icon small @click="EditarContato(item)" v-on="on">mdi-pencil</v-icon>
                                    </template>
                                    <span>Editar</span>
                                </v-tooltip>
                                <v-tooltip right>
                                    <template v-slot:activator="{ on }">
                                        <v-icon small @click="ExcluirContato(item)" v-on="on">mdi-delete</v-icon>
                                    </template>
                                    <span>Excluir</span>
                                </v-tooltip>
                            </template>

                        </v-data-table>

                    </v-tab-item>

                    <v-tab-item>
                        <div class="d-flex justify-end mb-3"><v-btn text color="primary" :loading="carregandoCrm" @click="CarregarCrm"><v-icon left>mdi-refresh</v-icon>Atualizar relacionamento</v-btn></div>
                        <v-alert v-if="erroCrm" type="error" text>{{ erroCrm }}</v-alert>
                        <v-progress-linear v-if="carregandoCrm" indeterminate color="primary"/>
                        <v-tabs v-model="crmAba" show-arrows class="mb-4"><v-tab>Captações</v-tab><v-tab>Atividades pendentes</v-tab><v-tab>Histórico</v-tab><v-tab>Doações realizadas</v-tab><v-tab>Documentos</v-tab></v-tabs>
                        <v-tabs-items v-model="crmAba">
                            <v-tab-item>
                                <h3 class="mb-2">Captações abertas</h3>
                                <v-data-table :headers="headersCrmCaptacao" :items="crm.oportunidades.filter(x => x.status === 'A')" no-data-text="Nenhuma captação aberta.">
                                    <template v-slot:[`item.actions`]="{ item: captacao }"><v-btn icon small aria-label="Abrir captação" @click="AbrirCaptacao(captacao.id)"><v-icon small>mdi-open-in-new</v-icon></v-btn></template>
                                    <template v-slot:[`item.valorTotal`]="{ item: captacao }">{{ MoedaCrm(captacao.valorTotal) }}</template>
                                    <template v-slot:[`item.percentual`]="{ item: captacao }">{{ captacao.percentual }}%</template>
                                    <template v-slot:[`item.status`]="{ item: captacao }">{{ StatusCrm(captacao.status) }}</template>
                                    <template v-slot:[`item.previsaoFechamento`]="{ item: captacao }">{{ DataCrm(captacao.previsaoFechamento) }}</template>
                                </v-data-table>
                                <h3 class="mt-5 mb-2">Captações encerradas</h3>
                                <v-data-table :headers="headersCrmCaptacao" :items="crm.oportunidades.filter(x => x.status !== 'A')" no-data-text="Nenhuma captação encerrada.">
                                    <template v-slot:[`item.actions`]="{ item: captacao }"><v-btn icon small aria-label="Abrir captação" @click="AbrirCaptacao(captacao.id)"><v-icon small>mdi-open-in-new</v-icon></v-btn></template>
                                    <template v-slot:[`item.valorTotal`]="{ item: captacao }">{{ MoedaCrm(captacao.valorTotal) }}</template>
                                    <template v-slot:[`item.percentual`]="{ item: captacao }">{{ captacao.percentual }}%</template>
                                    <template v-slot:[`item.status`]="{ item: captacao }">{{ StatusCrm(captacao.status) }}</template>
                                    <template v-slot:[`item.previsaoFechamento`]="{ item: captacao }">{{ DataCrm(captacao.previsaoFechamento) }}</template>
                                </v-data-table>
                            </v-tab-item>
                            <v-tab-item>
                                <v-data-table :headers="headersCrmAtividade" :items="crm.atividades.filter(x => x.situacao === 'P')" no-data-text="Nenhuma atividade pendente.">
                                    <template v-slot:[`item.actions`]="{ item: atividade }"><v-btn icon small aria-label="Abrir captação da atividade" @click="AbrirCaptacao(atividade.oportunidadeId)"><v-icon small>mdi-open-in-new</v-icon></v-btn></template>
                                    <template v-slot:[`item.dataPrevista`]="{ item: atividade }"><span :class="atividade.atrasada ? 'error--text font-weight-bold' : ''">{{ DataCrm(atividade.dataPrevista) }} {{ atividade.horaPrevista ? atividade.horaPrevista.slice(0, 5) : '' }}</span></template>
                                </v-data-table>
                            </v-tab-item>
                            <v-tab-item>
                                <v-list>
                                    <v-list-item v-for="evento in crm.historico" :key="evento.id"><v-list-item-content><v-list-item-title>{{ DataHoraCrm(evento.dataHora) }} · {{ evento.usuarioNome }}</v-list-item-title><div class="text-caption mb-1">{{ evento.tipo }}</div><div style="white-space: pre-wrap; overflow-wrap: anywhere">{{ evento.descricao }}</div></v-list-item-content></v-list-item>
                                </v-list>
                                <p v-if="!crm.historico.length" class="text--secondary">Nenhum registro de relacionamento.</p>
                            </v-tab-item>
                            <v-tab-item>
                                <p class="text-h6">Total de doações realizadas {{ MoedaCrm(crm.valorTotalDoacoes) }}</p>
                                <v-data-table :headers="headersCrmDoacao" :items="crm.doacoes" no-data-text="Nenhuma doação realizada.">
                                    <template v-slot:[`item.dataPagamento`]="{ item: doacao }">{{ DataCrm(doacao.dataPagamento) }}</template>
                                    <template v-slot:[`item.valor`]="{ item: doacao }">{{ MoedaCrm(doacao.valor) }}</template>
                                    <template v-slot:[`item.valorFinal`]="{ item: doacao }">{{ MoedaCrm(doacao.valorFinal) }}</template>
                                </v-data-table>
                            </v-tab-item>
                            <v-tab-item>
                                <v-list>
                                    <v-list-item v-for="captacao in crm.oportunidades.filter(x => x.anexo)" :key="captacao.id" @click="DownloadCrm(captacao)"><v-list-item-icon><v-icon>mdi-file-pdf-box</v-icon></v-list-item-icon><v-list-item-content><v-list-item-title>{{ captacao.anexo }}</v-list-item-title><v-list-item-subtitle>{{ captacao.descricao }}</v-list-item-subtitle></v-list-item-content><v-list-item-action><v-icon>mdi-download</v-icon></v-list-item-action></v-list-item>
                                </v-list>
                                <p v-if="!crm.oportunidades.some(x => x.anexo)" class="text--secondary">Nenhum documento associado às captações.</p>
                            </v-tab-item>
                        </v-tabs-items>
                    </v-tab-item>
                </v-tabs-items>
            </v-card-text>
        </v-card>

        <v-dialog v-model="dialogContato" width="1000">
            <v-card>
                <v-card-title class="headline primary white--text">Contato</v-card-title>
                <v-card-text class="mt-5">
                    <v-row>
                        <v-col cols="12" md="5">
                            <v-text-field v-model="contato.nome" label="Nome" :counter="255" maxlength="255" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="5">
                            <v-text-field v-model="contato.cargo" label="Cargo" :counter="25" maxlength="25" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-select v-model="contato.situacao" label="Situação" :items="situacoes" item-value="key" item-text="value" dense outlined/>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="4">
                            <v-text-field v-model="contato.cep" label="CEP" v-mask="mskCep" @change="ObterEndereco(item.cep)" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="5">
                            <v-text-field v-model="contato.logradouro" label="Logradouro" :counter="80" maxlength="80" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="3">
                            <v-text-field v-model="contato.bairro" label="Bairro" :counter="45" maxlength="45" dense outlined/>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="4">
                            <v-text-field v-model="contato.cidade" label="Cidade" :counter="45" maxlength="45" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="3">
                            <v-select v-model="contato.estado" label="Estado" :items="estados" item-value="key" item-text="value" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="5">
                            <v-text-field v-model="contato.pais" label="País" dense outlined/>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="3">
                            <v-text-field v-model="contato.telefone" label="Telefone" v-mask="mskTelefone" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="3">
                            <v-text-field v-model="contato.ramal" label="Ramal" v-mask="mskTelefone" :counter="10" maxlength="10" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="3">
                            <v-text-field v-model="contato.celular" label="Celular" v-mask="mskTelefone" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="3">
                            <v-text-field v-model="contato.email" label="E-mail" :counter="60" maxlength="60" dense outlined/>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="secundary" text @click="dialogContato = false">Fechar</v-btn>
                    <v-btn color="primary" text @click="SalvarContato()">Salvar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <cadastro-captacao v-if="dialogCaptacao" :item="captacaoCrm" :value="dialogCaptacao" @fechou="dialogCaptacao = false" @salvou="CarregarCrm" @atualizado="CarregarCrm"/>

        <v-overlay :value="salvando">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

    </v-dialog>

</template>
<script>
import { MskCpf, MskCnpjAlfa, MskTelefone, MskCep } from '@/core/domain/shared/Global';
import Doador from '@/core/domain/doacao/Doador';
import Contato from '@/core/domain/doacao/Contato';
import Parametro from '@/core/domain/geral/Parametro';
import { ParametroService, EnderecoService, EstadoEnumService, RespostaBasicaEnumService, SimNaoEnumService, SituacaoEnumService, TipoPessoaEnumService } from '@/core/services/geral';
import { RelacionamentoService, DoadorService, ContribuicaoEnumService, RegiaoService } from '@/core/services/doacao';
import PlanoContaService from '@/core/services/financeiro/PlanoContaService';
import FormaPagamentoEnumService from '../../../core/services/financeiro/FormaPagamentoEnumService';
import { PessoalService, ProjetoService } from '../../../core/services/projetos';
import OportunidadeService from '../../../core/services/doacao/OportunidadeService';
import CadastroCaptacao from '../oportunidade/Cadastro.vue';

export default {
    components: { CadastroCaptacao },
    props:{
        item: {
            required: true
        },
        value: {}
    },
    watch: { 
        item: function() {
            this.requisicaoCrm++;
            this.crm = { oportunidades: [], historico: [], atividades: [], doacoes: [], valorTotalDoacoes: 0 };
            this.dialogCaptacao = false;
            this.crmAba = 0;
            if (this.dialog && this.tabActive === 3) this.CarregarCrm();
            if ('formCadastroDoador' in this.$refs)
                this.$refs.formCadastroDoador.resetValidation();
            
            if(this.item.id > 0){
                this.projetos.push(this.item.projeto);
            }
        },
        value: function() {
            this.dialog = this.value;
        },
        dialog: function() {
            if (!this.dialog) {
                this.requisicaoCrm++;
                this.dialogCaptacao = false;
                this.$emit('fechou');
            } else if (this.tabActive === 3) this.CarregarCrm();
        },
        tabActive(valor) { if (valor === 3 && this.dialog) this.CarregarCrm(); },
        'item.tipo': {
            handler: function (val) {
                if (val === 0){
                    this.mskCpfCnpj = MskCpf;
                    this.lblCpfCnpj = 'CPF';
                    this.lblIdentidadeInscricaoEstadual = 'Identidade';
                    this.lblNascimentoFundacao = 'Nascimento';
                }
                else {
                    this.mskCpfCnpj = MskCnpjAlfa;
                    this.lblCpfCnpj = 'CNPJ';
                    this.lblIdentidadeInscricaoEstadual = 'Inscrição Estadual';
                    this.lblNascimentoFundacao = 'Fundação';
                }
            },
            deep: true
        },
        "item.planoContaId": function(){

            if (this.item.planoContaId > 0){
                let planoConta = this.planoContas.find(x => x.id == this.item.planoContaId);
                this.planoContaItens = planoConta.itens;

                // if (this.planoContaItens.length > 0){
                //     this.item.planoContaItemId = this.planoContaItens[0].id;
                // }
            }
        },
        "item.formaDoacao": function(){
            if ('formCadastroDoador' in this.$refs)
                this.$refs.formCadastroDoador.resetValidation();
        },
        "item.estado": function(val){
            if(!val) return;
            new EnderecoService().ObterMunicipios(this.item.estado).then(
                res => {
                    this.municipios = res.data;
                },
                err => this.$swal('Aviso', err.response.data, 'error')
            );
        },
        searchIndicador (val) {
            if (this.isLoading) return;
            if (!val) return;
            
            this.isLoading = true
            this.service.AutoComplete(val)
                .then(
                    res => this.indicadores = res.data,
                    err => this.$swal('Aviso', err.response.data, 'error')
                )
                .finally(() => (this.isLoading = false))
        },
        searchProjeto (val) {
            if (this.item.projetoId) return;
            if (this.isProjetoLoading) return;
            if (!val) return;
            
            this.isProjetoLoading = true
            const projetoService = new ProjetoService();
            projetoService.AutoComplete(val)
                .then(
                    res => {
                        this.projetos = res.data;
                    },
                    err => this.$swal('Aviso', err.response.data, 'error')
                )
                .finally(() => (this.isProjetoLoading = false))
        },
    },
    data: () => ({
        service: new DoadorService(),
        crmService: new OportunidadeService(),
        crm: { oportunidades: [], historico: [], atividades: [], doacoes: [], valorTotalDoacoes: 0 },
        crmAba: 0, carregandoCrm: false, erroCrm: '', requisicaoCrm: 0,
        dialogCaptacao: false, captacaoCrm: {},
        headersCrmCaptacao: [{ text: 'Abrir', value: 'actions', sortable: false }, { text: 'Descrição', value: 'descricao' }, { text: 'Valor', value: 'valorTotal' }, { text: 'Probabilidade', value: 'percentual' }, { text: 'Status', value: 'status' }, { text: 'Responsável', value: 'responsavelNome' }, { text: 'Previsão', value: 'previsaoFechamento' }],
        headersCrmAtividade: [{ text: 'Abrir', value: 'actions', sortable: false }, { text: 'Descrição', value: 'descricao' }, { text: 'Captação', value: 'oportunidadeDescricao' }, { text: 'Responsável', value: 'responsavelNome' }, { text: 'Previsão', value: 'dataPrevista' }],
        headersCrmDoacao: [{ text: 'Código', value: 'id' }, { text: 'Descrição', value: 'descricao' }, { text: 'Pagamento', value: 'dataPagamento' }, { text: 'Valor', value: 'valor' }, { text: 'Valor realizado', value: 'valorFinal' }],
        
        mskCpfCnpj: MskCpf,
        mskTelefone: MskTelefone,
        mskCep: MskCep,
        lblCpfCnpj: 'CPF',
        lblIdentidadeInscricaoEstadual: 'Identidade',
        lblNascimentoFundacao: 'Nascimento',
        valid: true,
        dialog: false,
        dialogContato: false,
        isLoading: false,
        isProjetoLoading: false,
        fieldRules: [
            v => !!v || 'Campo obrigatório'
        ],
        diaSemanaRules: [
            v => !!v && /^(?:[1-9]|[12]\d|3[01])$/.test(v) || 'Dia bom deve ser entre 1 e 31'
        ],
        contatoId: 0,
        tabActive: null,
        searchIndicador: null,
        searchProjeto: null,
        parametro: new Parametro(),
        tipos: [],
        estados: [],
        municipios: [],
        situacoes: [],
        relacionamentos: [],
        simNaos: [],
        respostaBasicas: [],
        planoContas: [],
        planoContaItens: [],
        indicadores: [],
        contribuicoes: [],
        formaPagamentos: [],
        projetos: [],
        regioes: [],
        atendentes: [],
        sessionApp: {},
        contato: new Contato(),
        headerContato: [
            { text: '', value:'actions', sortable: false  },
            { text: 'Nome', value: 'nome' },
            { text: 'Cargo', value: 'cargo' },
            { text: 'Telefone', value: 'telefone' },
            { text: 'Ramal', value: 'ramal' },
            { text: 'Celular', value: 'celular' },
            { text: 'E-mail', value: 'email' },
        ],
        salvando: false
    }),
    methods: {
        async CarregarCrm() {
            const requisicao = ++this.requisicaoCrm;
            if (!this.item.id) return;
            this.carregandoCrm = true;
            this.erroCrm = '';
            try {
                const res = await this.crmService.ResumoDoador(this.item.id);
                if (requisicao === this.requisicaoCrm) this.crm = Object.assign({ oportunidades: [], historico: [], atividades: [], doacoes: [], valorTotalDoacoes: 0 }, res.data);
            } catch (err) { if (requisicao === this.requisicaoCrm) this.erroCrm = this.MensagemCrm(err); }
            finally { if (requisicao === this.requisicaoCrm) this.carregandoCrm = false; }
        },
        async AbrirCaptacao(id) {
            const doadorId = this.item.id;
            try {
                const res = await this.crmService.ObterPorId(id, 'Doador.Contatos');
                if (doadorId !== this.item.id || !this.dialog) return;
                this.captacaoCrm = res.data;
                this.dialogCaptacao = true;
            } catch (err) { this.erroCrm = this.MensagemCrm(err); }
        },
        async DownloadCrm(captacao) { try { await this.crmService.DownloadDocumento(captacao.id, captacao.anexo); } catch (err) { this.erroCrm = this.MensagemCrm(err); } },
        StatusCrm(valor) { return { A: 'Aberto', F: 'Fechado', C: 'Cancelado' }[valor] || valor; },
        DataCrm(valor) { const partes = (valor || '').slice(0, 10).split('-'); return partes.length === 3 ? partes.reverse().join('/') : ''; },
        DataHoraCrm(valor) { return valor ? new Date(valor).toLocaleString('pt-BR') : ''; },
        MoedaCrm(valor) { return Number(valor || 0).toMoeda(true); },
        MensagemCrm(err) { const data = err.response && err.response.data; return typeof data === 'string' ? data : (data && (data.detail || data.title)) || 'Não foi possível carregar o relacionamento do doador.'; },
        AbrirDialogContato(contatoId){
            this.contatoId = contatoId;
            this.contato = new Contato();
            this.dialogContato = true;
        },
        EditarContato(item){
            this.contato = new Contato(item);
            this.dialogContato = true;
        },
        ExcluirContato(item) {
            this.$swal({
              title: 'Atenção!',
              text: 'Tem certeza que deseja excluir o contato atual?',
              type: 'question',
              showCancelButton: true,
              confirmButtonText: 'Sim',
              cancelButtonText: 'Não',
              showCloseButton: true,
              showLoaderOnConfirm: true,
              preConfirm: () => {
                  return this.service.ExcluirContato(item.doadorId, item.id)
                          .then(res => {
                              if (res.status == 200){
                                  return res;
                              }
                          }, 
                          err => this.$swal('Aviso', err.response.data, 'error')
                      )
                  },
              allowOutsideClick: () => !this.$swal.isLoading()
              })
              .then((result) => {
                  if(result.value) {
                    this.$swal('Aviso', result.value.data, result.value.status == 200 ? 'success' : 'warning');
                    const index = this.item.contatos.indexOf(item);
                    this.item.contatos.splice(index, 1);
                  }
              })
        },
        SalvarContato(){

            if (this.contato.doadorId > 0){
                this.service.AlterarContato(this.item.id, this.contato.id, this.contato)
                .then(res => {
                    this.item.contatos = res.data;
                },
                err => {
                    this.$swal('Aviso', err.response.data, 'error');
                })
                .finally(() => {
                    this.contato = new Contato();
                    this.dialogContato = false;
                });
            }
            else {
                this.service.IncluirContato(this.item.id, this.contato)
                .then(res => {
                    this.item.contatos.push(res.data);
                },
                err => {
                    this.$swal('Aviso', err.response.data, 'error');
                })
                .finally(() => {
                    this.contato = new Contato();
                    this.dialogContato = false;
                });
            }
        },
        VerificarExistente(){
            this.service.VerificarExistente(this.item.cpfCnpj).then(
                res => {
                    let resposta = res.data;
                    if(resposta){
                        this.item.cpfCnpj = "";
                        this.$swal('Aviso', "Já existe um Doador com esse CPF/CNPJ cadastrado.", 'warning')
                    }
                },
                err => this.$swal('Aviso', err.response.data, 'error')
            )
        },
        save() {
            if(!this.$refs.formCadastroDoador.validate()){
                this.tabActive = 0;
                return;
            }
            if(!this.$refs.formCadastroNFSe.validate()){
                this.tabActive = 1;
                return;
            }

            this.salvando = true;

            //GAMBIARRA PARA CORRIGIR TROCA DE PROJETO
            this.item.projeto = null;

            let modelo = new Doador(this.item);

            this.service.Salvar(modelo).then(
                res => {
                    this.$swal('Aviso', 'Operação realizada com sucesso!', res.status == 201 || res.status == 200 ? 'success' : 'warning');
                    this.$emit('salvou');
                    this.Close();
                }, 
                err =>  {
                    if (err.response.status == 400) {
                        this.$swal('Aviso', err.response.data.title, 'warning')    
                    }
                    else {
                        this.$swal('Aviso', err.response.data, 'error')
                    }
                }
            ).finally(() => {
                this.salvando = false;
            })
        },
        Close() {
            this.dialog = false;
        },
        ObterEndereco(cep){
            const enderecoService = new EnderecoService();
            enderecoService.ObterPorCep(cep)
            .then(
                res => {
                    let endereco = res.data;
                    if (endereco) {
                        this.item.logradouro = endereco.logradouro;
                        this.item.bairro = endereco.bairro;
                        this.item.cidade = endereco.municipio;
                        this.item.estado = endereco.estado;
                        this.item.municipioId = endereco.municipioId;
                        this.item.pais = endereco.pais;
                    }
                },
                err => {
                    this.$swal('Aviso', err.message, 'error');
                }
            );
        }
    },
    beforeDestroy() { this.requisicaoCrm++; },
    beforeUpdate(){
        if (!this.dialog){
            this.$emit('fechou');
        }
    },
    mounted() {

        const parametroService = new ParametroService();
        parametroService.ObterPorId(1)
            .then(
                res => {
                    this.parametro = new Parametro(res.data);
                },
                err => {
                    this.$swal('Aviso', err.message, 'error')}
            );

        const tipoEnumService = new TipoPessoaEnumService();
        tipoEnumService.Listar()
            .then(
                res => {
                    this.tipos = res.data;
                },
                err => {
                    this.$swal('Aviso', err.message, 'error');
                }
            );

        const estadoEnumService = new EstadoEnumService();
        estadoEnumService.Listar()
            .then(
                res => {
                    this.estados = res.data;
                },
                err => {
                    this.$swal('Aviso', err.message, 'error');
                }
            );

        const situacaoEnumService = new SituacaoEnumService();
        situacaoEnumService.Listar()
            .then(
                res => {
                    this.situacoes = res.data;
                },
                err => {
                    this.$swal('Aviso', err.message, 'error');
                }
            );

        const simNaoEnumService = new SimNaoEnumService();
        simNaoEnumService.Listar()
            .then(
                res => {
                    this.simNaos = res.data;
                },
                err => {
                    this.$swal('Aviso', err.message, 'error');
                }
            );

        const contribuicaoEnumService = new ContribuicaoEnumService();
        contribuicaoEnumService.Listar()
            .then(
                res => {
                    this.contribuicoes = res.data;
                },
                err => {
                    this.$swal('Aviso', err.message, 'error');
                }
            );


        const relacionamentoService = new RelacionamentoService();
        relacionamentoService.ListarTudo()
            .then(
                res => {
                    this.relacionamentos = res.data.items;
                },
                err => {
                    this.$swal('Aviso', err.message, 'error');
                }
            );

        const planoContaService = new PlanoContaService();
        planoContaService.ListarByTipo('R', "Itens.PlanoContaContabil, Itens.PlanoContaContabilLivre, Itens.PlanoContaContabilRestrito")
            .then(
                res => {
                    this.planoContas = res.data.items;
                },
                err => {
                    this.$swal('Aviso', err.message, 'error');
                }
            );

        let formaPagamentoEnumService = new FormaPagamentoEnumService();
        formaPagamentoEnumService.Listar()
            .then(
                res => {
                    this.formaPagamentos = res.data;
                },
                err => {
                    this.$swal('Aviso', err.message, 'error');
                }
            );

        const respostaBasicaEnumService = new RespostaBasicaEnumService();
        respostaBasicaEnumService.Listar()
            .then(
                res => {
                    this.respostaBasicas = res.data;
                },
                err => {
                    this.$swal('Aviso', err.message, 'error');
                }
            );

        const regiaoService = new RegiaoService();
        regiaoService.ListarTudo()
            .then(
                res => {
                    this.regioes = res.data.items;
                    this.regioes.unshift({
                        id: null,
                        nome: '---NENHUM---'
                    })
                },
                err => {
                    this.$swal('Aviso', err.message, 'error');
                }
            );

        const pessoalService = new PessoalService();
        pessoalService.ObterComUsuario()
          .then(
              res => {
                  this.atendentes = res.data;
                  this.atendentes.unshift({
                    id: null,
                    nome: '---NENHUM---'
                  });
              },
              err => {
                  this.$swal('Aviso', err.message, 'error');
              }
          );
    }
}
</script>
